import { MouseEvent, useRef, useState } from 'react';
import { setSchedulePublicEndIntervalDate } from 'entities/schedulePublic';
import { useAppDispatch, useAppSelector } from 'shared/lib';

export const useScroll = () => {
  const containerScheduleRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);
  const lastTimeRef = useRef<number>(0);
  const lastYRef = useRef<number>(0);

  const [isScrollToTopVisible, setIsScrollToTopVisible] =
    useState<boolean>(false);

  const { endIntervalDate } = useAppSelector(
    (state) => state.schedulePublicReducer,
  );
  const dispatch = useAppDispatch();

  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    setIsDragging(true);
    e.preventDefault();
    const currentRef = containerScheduleRef;
    setStartY(e.pageY - (currentRef.current?.offsetTop || 0));
    setScrollTop(currentRef.current?.scrollTop || 0);
    lastTimeRef.current = performance.now();
    lastYRef.current = e.pageY;
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;
    e.preventDefault();
    const currentRef = containerScheduleRef;
    const y = e.pageY - (currentRef.current?.offsetTop || 0);
    const walk = (y - startY) * 0.85;
    if (currentRef.current) {
      currentRef.current.scrollTop = scrollTop - walk;
    }
    const now = performance.now();
    lastYRef.current = e.pageY;
    lastTimeRef.current = now;
  };

  const loadMoreData = () => {
    dispatch(setSchedulePublicEndIntervalDate(endIntervalDate.add(10, 'day')));
  };

  const handleScroll = () => {
    if (containerScheduleRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        containerScheduleRef.current;
      setIsScrollToTopVisible(scrollTop > 300);
      if (scrollTop + clientHeight >= scrollHeight - scrollHeight * 0.05) {
        loadMoreData();
      }
    }
  };

  const scrollToTop = () => {
    if (containerScheduleRef.current) {
      containerScheduleRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return {
    containerScheduleRef,
    isDragging,
    isScrollToTopVisible,
    handleScroll,
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
    scrollToTop,
  };
};
